import idx from "idx"
// import { toLowerCaseIfExists } from "@jsUtils"

/**
 * transform - manipulate data from the graphql query
 * @param {object} contentfulCompanyPillars
 * @returns {object}
 */
function transform(contentfulCompanyPillars) {
  const slides = contentfulCompanyPillars
    ? contentfulCompanyPillars.map(pillar => {
        return {
          id: idx(pillar, _ => _.id),
          title: idx(pillar, _ => _.title),
          headline: idx(pillar, _ => _.headline),
          description: idx(pillar, _ => _.description.description),
          image: idx(pillar, _ => _.image)
        }
      })
    : []
  return {
    slides
  }
}

export default { transform }
